import { isLightOrDark } from 'src/services/color';
import SimpleModel from 'src/models/SimpleModel';

export default class SvgMarker extends SimpleModel {
  height = null;

  innerColor = null;

  outerColor = null;

  outline = false;

  svg = null;

  width = null;

  constructor(svg, { height, width, innerColor = null, outerColor = null, outline = false }) {
    super();
    this.insert({ height, width, svg, innerColor, outerColor, outline });
  }

  /**
   * Replaces the svg string with the specified innerColor and outerColor
   * @param {String} colorOverride
   * @returns {String}
   */
  colorize(colorOverride = 'none', outline = false) {
    let { innerColor, outerColor, svg } = this;

    if (colorOverride === 'none') {
      colorOverride = null;
    }

    if (colorOverride) {
      outerColor = colorOverride;
      innerColor = isLightOrDark(outerColor) === 'light' ? '#000' : '#FFF';
    }

    const outlineDisplay = outline ? 'inline' : 'none';

    svg = svg
      .replace(/\{\{ outerColor \}\}/g, outerColor)
      .replace(/\{\{ innerColor \}\}/g, innerColor)
      .replace(/\{\{ outlineDisplay \}\}/g, outlineDisplay);

    return svg;
  }

  /**
   * Generates a Base64 Image with an optional color override.
   *
   * @param {String} colorOverride
   * @param {Boolean} outline
   * @returns {Object}
   */
  generateBase64Svg(colorOverride = null, outline = false) {
    const { height, width } = this;

    const svg = this.colorize(colorOverride, outline);

    return {
      svg: `data:image/svg+xml;base64,${btoa(svg)}`,
      height,
      width,
    };
  }

  /**
   * Creates and loads an HTML Image from the SVG.
   *
   * @param {String} colorOverride
   * @param {Boolean} outline
   * @returns {Promise<Image>}
   */
  async toImage(colorOverride, outline) {
    return new Promise((resolve) => {
      const { svg, height, width } = this.generateBase64Svg(colorOverride, outline);
      const image = new Image(width, height);
      image.onload = () => {
        resolve(image);
      };
      image.src = svg;
    });
  }
}
